import * as yup from 'yup';


import {addressFormConstants} from '../../Address/AddressForm';


export const BILLING_DATA_ADDITIONAL_TEXT_MAX = 200;

export const BILLING_DATA_TAX_NUMBER_MAX = 50;


export const SCHEMA_BILLING_DATA_ADDITIONAL_TEXT = yup.string()
    .freeText()
    .nullable()
    .max(BILLING_DATA_ADDITIONAL_TEXT_MAX);

export const SCHEMA_BILLING_DATA_TAX_NUMBER = yup.string()
    .strictText()
    .nullable()
    .max(BILLING_DATA_TAX_NUMBER_MAX)
    .required();


export const SCHEMA_BILLING_DATA = yup.object()
    .shape({
        additionalInvoiceText: SCHEMA_BILLING_DATA_ADDITIONAL_TEXT,
        address: addressFormConstants.SCHEMA_ADDRESS.clone()
            .nullable()
            .notRequired()
            .default(undefined),
        isBillingAddressMainAddress: yup.boolean()
            .required()
            .default(true),
        taxNumber: SCHEMA_BILLING_DATA_TAX_NUMBER
    });
